export class Distance {
    //-------------------------------------------------------------------------
    /**
     * Calculate the distance between two sets of coordinates
     * @param x1 
     * @param y1 
     * @param x2 
     * @param y2 
     */
    //-------------------------------------------------------------------------
    static Between(x1: number, y1: number, x2: number, y2: number): number {
        let dx = x1 - x2;
        let dy = y1 - y2;

        return Math.sqrt(dx * dx + dy * dy);
    }
}